<template>
  <div
    class="wrapper"
    @click.stop="$emit('close')"
  >
    <div
      :class="'color-picker '+position"
      @click.stop=""
    >
      <div id="color-picker-container" />
      <input
        v-if="includeInput"
        v-model="color"
        class="input"
        @input="value => {debounceUpdateWheel(value.target.value)}"
      >
      <small
        v-if="inputWarning"
        class="input-warning"
      >Please select or input a valid hex color (e.g. #FFFFFF or
        #FFF)</small>
      <div
        :style="'background-color: '+color+';'"
        class="preview"
      />
      <div class="color-picker-buttons">
        <button
          class="picker_cancel_btn"
          @click.stop="$emit('close')"
        >
          Cancel
        </button>
        <button
          :disabled="inputWarning"
          class="picker_select_btn"
          @click.stop="updateValue();"
        >
          Select
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ReinventedColorWheel from "reinvented-color-wheel";

export default {
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    includeInput: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'below',
      validator: function (value) {
        // The value must match one of these strings
        return ['above', 'below'].indexOf(value) !== -1
      }
    },
  },
  emits: ['add', 'close', 'update:modelValue'],
  data() {
    return {
      color: '#f3625a',
      picker: null,
      inputWarning: false,
    }
  },
  mounted() {
    if (this.modelValue) this.color = this.modelValue;

    this.picker = new ReinventedColorWheel({
      // appendTo is the only required property. specify the parent element of the color wheel.
      appendTo: document.getElementById('color-picker-container'),

      // followings are optional properties and their default values.

      // initial color (can be specified in hsv / hsl / rgb / hex)
      // hsv: [0, 100, 100],
      // hsl: [0, 100, 50],
      // rgb: [255, 0, 0],
      hex: this.color,

      // appearance
      wheelDiameter: 200,
      wheelThickness: 20,
      handleDiameter: 16,
      wheelReflectsSaturation: true,

      // handler
      onChange: (color) => {
        this.color = color.hex;
      },
    });
  },
  beforeUnmount() {
    document.getElementById('color-picker-container').innerHTML = '';
  },
  methods: {
    debounceUpdateWheel: _.debounce(function (color) {
      let regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
      if (color.match(regex)) {
        this.inputWarning = false;
        this.picker.hex = color;
      } else {
        this.inputWarning = true;
      }
    }, 500),
    updateValue() {
      let regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
      if (this.color.match(regex)) {
        this.inputWarning = false;
        this.$emit('update:modelValue', this.color);
        this.$emit('add', this.color);
        this.$emit('close');
      } else {
        this.inputWarning = true;
      }
    }
  }
}
</script>

<style scoped>
@import 'reinvented-color-wheel/css/reinvented-color-wheel.min.css';

.wrapper {
  z-index: 999;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.color-picker {
  z-index: 999;
  background: #FBFAFA;
  padding: 10px;
  border: solid 1px lightgray;
  border-radius: .75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-picker.above {
  bottom: 0;
}

.color-picker.below {
  top: 0;
}

.input {
  text-align: center;
  width: 100%;
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  height: 2.5rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  margin: 5px 0;
}

.input-warning {
  color: red;
}

.preview {
  width: 100%;
  height: 30px;
  border: solid 1px lightgray;
  border-radius: 12px;
}

.color-picker-buttons {
  display: flex;
  justify-content: space-evenly;
  padding: 5px;
}

.color-picker-buttons > button {
  cursor: pointer;
  height: 40px;
  width: 100px;
  font-size: 16px;
  margin: 5px;
  border-radius: .75rem;
  font-size: 1rem;
  letter-spacing: -0.015625em;
  transition: .3s;
}

.picker_cancel_btn {
  color: #37B2A8;
  border: 2px solid #37B2A8;
  background-color: #FFFFFF;
}

.picker_select_btn {
  background-color: #37B2A8;
  color: #FFFFFF;
}

.picker_select_btn:hover {
  background-color: #0A8080;
}

</style>
